import { Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { RouterProvider } from "react-router-dom";
import router from "../routes/config";
import configureStore from "../configure-store";
import { logFireBaseEvent } from "../firebase";
import ar from 'antd/locale/ar_EG';


const store = configureStore();

function App() {
    useEffect(() => {
        logFireBaseEvent({ name: "Apply_Lead_Started" });
    }, []);
    return (
        <Provider store={store}>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: "#ff9800",
                        fontFamily: "Noto Sans Arabic, Noto Sans",
                    },
                }}
                locale={ar}
            >
                <Suspense fallback="loading...">
                    <RouterProvider router={router} />
                </Suspense>
            </ConfigProvider>
        </Provider>
    );
}

export default App;
